module.exports = __webpack_public_path__ + "resources/icon_94_jingyanno.17082795d200265f.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/manage-dialog/img/icon_94_jingyanno.png
// module id = 617
// module chunks = 0 1 2 3